import {t} from '../../common/getTranslations';
import {TicketHistoryBuyDetailVo} from '../../common/shared/api/nicolas/vo/TicketHistoryBuyDetailVo.interface';
import {ContentTicketHistoryBuyDetail, TicketType} from '../generated/types';
import {createTicketHistoryBuyExtraSimple} from './TicketHistoryBuyExtraSimple';
import {createTicketType} from './TicketType';

export function createTicketHistoryBuyDetail({
  pay_id,
  ticket_type,
  price,
  list,
  expired_amount,
  available_amount,
  created_dt,
}: TicketHistoryBuyDetailVo): ContentTicketHistoryBuyDetail {
  const ticketType = createTicketType(ticket_type);

  return {
    availableAmount: available_amount,
    createdDt: created_dt,
    expiredAmount: expired_amount,
    list: list?.map(createTicketHistoryBuyExtraSimple),
    payId: pay_id ? BigInt(pay_id).toString() : undefined,
    price,
    ticketType,
    ticketTypeText: getTicketTypeText(ticketType),
    isSet:
      ticketType === TicketType.BuySet || ticketType === TicketType.RentSet,
  };
}

function getTicketTypeText(ticketType: TicketType) {
  switch (ticketType) {
    case TicketType.BuyCashSingle:
    case TicketType.BuyCashDiscountSingle:
      return t('common_ticket_possession_cash');
    case TicketType.RentCashSingle:
    case TicketType.RentCashDiscountSingle:
      return t('common_ticket_rental_cash');
    case TicketType.BuySet:
      return t('common_ticket_possession_set');
    case TicketType.RentSet:
      return t('common_ticket_rental_set');
  }

  return undefined;
}
